import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { applyThemePreference, getThemePreference } from "./lib/theme";
import "./styles/global.css";
import "./styles/ceinexus.css";
import "./styles/logo.css";
import "./styles/engineering-workspace.css";
import "./styles/command-center.css";
import "./styles/engineering-answer-types.css";
import "./styles/quality-feedback.css";
import "./styles/answer-quality.css";
import "./styles/source-workspace.css";
import "./styles/inspector-answer.css";
import "./styles/worldclass.css";
import "./styles/worldclass-modules.css";

// Netlify production build trigger after repository reconnect: 2026-08-16 13:09 CDT.

// index.html used to do this in a pre-paint inline <script>, but the site's
// own CSP (script-src 'self', no unsafe-inline/hash/nonce) silently blocks
// all inline scripts — reproduced live: explicit "Light"/"Dark" selection
// saved to localStorage correctly but never actually applied data-theme to
// <html>, so only the OS-level "system" preference ever took visible
// effect. This external module script isn't blocked by that CSP, so it's
// the earliest CSP-compliant point to apply it — there's a brief flash of
// the wrong theme before React mounts where the old approach had none, but
// that's strictly better than a toggle that silently never worked at all.
applyThemePreference(getThemePreference());

const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);